import { linkWithCurrentQueryString } from '../../../../utils/router';
import './styles.scss';

import { isEqual } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import CardPlayButton from '../../../atoms/buttons/CardPlayButton';
import Thumbnail from '../../../atoms/images/Thumbnail';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { ArtistPagePath } from '../../../pages/Artist';
import { TrackPagePath } from '../../../pages/Track';

import { ThumbnailWithPlayButtonProps } from './types';

const classes = new BEM('thumbnail');

export default class ThumbnailWithPlayButton extends React.Component<ThumbnailWithPlayButtonProps> {

  shouldComponentUpdate(nextProps: ThumbnailWithPlayButtonProps) {
    // WTF is all this?
    return nextProps.trackId !== this.props.trackId
      || nextProps.displayButtonOnHover !== this.props.displayButtonOnHover
      || nextProps.isPlaying !== this.props.isPlaying
      || !isEqual(nextProps.title, this.props.title)
      || !isEqual(nextProps.artist, this.props.artist);
  }

  onClickPlayButton = () => {
    const { isPlaying, pause, play } = this.props;
    isPlaying ? pause() : play();
  }

  renderTrackInfo() {
    return (
      <div {...classes('track-info')}>
        <Heading
          is="h5"
          {...classes('track-info__title')}
          text={this.props.title!.title}
          maxTextLength={25}
          hyperLinkProps={{
            href: linkWithCurrentQueryString(TrackPagePath(this.props.title!.slug)),
          }}
        />
        <Span
          size="small"
          {...classes('track-info__artist')}
          text={this.props.artist!.name}
          maxTextLength={20}
          hyperLinkProps={{
            href: linkWithCurrentQueryString(ArtistPagePath(this.props.artist!.slug)),
          }}
        />
      </div>
    );
  }

  render() {
    const {
      artist,
      className,
      displayButtonOnHover,
      isPlaying,
      pause: unusedPause,
      play: unusedPlay,
      title,
      trackId: unusedTrackId,
      ...thumbnailProps
    } = this.props;

    const showTrackInfo = !!artist && !!title;
    const classModifiers = {
      'with-play-button': true,
      'button-on-hover': !!displayButtonOnHover,
      'with-track-info': showTrackInfo,
      'is-playing': isPlaying,
    };

    const blurredImage = thumbnailProps.responsiveAssets && thumbnailProps.responsiveAssets.blur ?
      thumbnailProps.responsiveAssets.blur[0].path : null;

    return (
      <Thumbnail
        {...classes('', classModifiers, className) }
        {...thumbnailProps}
      >
        {showTrackInfo && this.renderTrackInfo()}
        <CardPlayButton
          blurredImage={blurredImage}
          isPlaying={isPlaying}
          onClick={this.onClickPlayButton}
          {...classes('play-button') }
        />
      </Thumbnail>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/buttons/ThumbnailWithPlayButton/component.tsx